import { state_select } from "Explore/Config/FilterData";
import {
  indicatorList,
  sortDirectionOptions,
  timeSpanOptions,
} from "Explore/Config/FilterConfig";
import { Checkbox, Select } from "antd";
import styles from "./FiltersFaculty.module.scss";
import ListFilter from "Explore/Components/ListFilter";
import FilterItem from "Explore/Components/ListFilter/FilterItem";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import VillaOutlinedIcon from "@mui/icons-material/VillaOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import SortIcon from "@mui/icons-material/Sort";
import SwapVertIcon from "@mui/icons-material/SwapVert";

const FilterFaculty = ({
  filter: filterProps,
  updateFilter: updateFilterProps,
}) => {
  const filter = filterProps;
  const updateFilter = updateFilterProps;

  if (!filter || !updateFilter) {
    return null;
  }

  const sortByOptions = indicatorList.filter((item) =>
    (filter.indicators || []).includes(item.value)
  );

  const handleTimeSpanChange = (value) => {
    updateFilter({ time_span: value });
  };

  const handleIndicatorsChange = (nextIndicators) => {
    const safeIndicators = nextIndicators?.length
      ? nextIndicators
      : [indicatorList[0].value];
    const nextSortBy = safeIndicators.includes(filter.order_by)
      ? filter.order_by
      : safeIndicators[0];

    updateFilter({
      indicators: safeIndicators,
      order_by: nextSortBy,
    });
  };

  const handleLocationChange = (nextLocation) => {
    const safeLocation = nextLocation?.length
      ? nextLocation
      : state_select.slice(0, 3).map((item) => item.value);
    updateFilter({ location: safeLocation });
  };

  return (
    <ListFilter className={styles["filters-faculty"]} showClearButton={false}>
      <FilterItem
        title="Timestamp"
        filterValue={filter.time_span}
        defaultOpen
        icon={<ScheduleOutlinedIcon />}
      >
        <div className={styles["facet-search"]}>
          {timeSpanOptions.map((item) => (
            <Checkbox
              key={String(item.value)}
              checked={filter.time_span === item.value}
              onChange={(e) => {
                if (e.target.checked) {
                  handleTimeSpanChange(item.value);
                }
              }}
            >
              {item.label}
            </Checkbox>
          ))}
        </div>
      </FilterItem>

      <FilterItem
        title="State"
        filterValue={filter.location}
        defaultOpen
        icon={<VillaOutlinedIcon />}
      >
        <Select
          mode="multiple"
          allowClear
          style={{ width: "100%" }}
          placeholder="Choose states"
          options={state_select}
          value={filter.location}
          onChange={handleLocationChange}
        />
      </FilterItem>

      <FilterItem
        title="Indicator"
        filterValue={filter.indicators}
        defaultOpen
        icon={<BarChartOutlinedIcon />}
      >
        <Select
          mode="multiple"
          allowClear
          style={{ width: "100%" }}
          placeholder="Choose indicators"
          options={indicatorList}
          value={filter.indicators}
          onChange={handleIndicatorsChange}
        />
      </FilterItem>

      <FilterItem
        title="Sort By"
        filterValue={filter.order_by}
        defaultOpen
        icon={<SortIcon />}
      >
        <Select
          style={{ width: "100%" }}
          options={sortByOptions}
          value={filter.order_by}
          onChange={(value) => updateFilter({ order_by: value })}
          placeholder="Select sort field"
        />
      </FilterItem>

      <FilterItem
        title="Sort Direction"
        filterValue={filter.order_direction}
        defaultOpen
        icon={<SwapVertIcon />}
      >
        <Select
          style={{ width: "100%" }}
          options={sortDirectionOptions}
          value={filter.order_direction}
          onChange={(value) => updateFilter({ order_direction: value })}
          placeholder="Select direction"
        />
      </FilterItem>
    </ListFilter>
  );
};

export default FilterFaculty;
